import { Link } from "react-router-dom";

const productLinks = [
  { label: "AI Intake Agent", href: "/products#intake-agent" },
  { label: "AI Appointment Maker", href: "/products#appointment-maker" },
  { label: "AI Document Intelligence", href: "/products#document-intelligence" },
  { label: "AI Knowledge Assistant", href: "/products#knowledge-assistant" },
  { label: "All Bundles", href: "/products#bundles" },
];

const solutionLinks = [
  { label: "Law Firms", href: "/solutions#law-firms" },
  { label: "Consulting Firms", href: "/solutions#consulting-firms" },
  { label: "Manufacturing", href: "/solutions#manufacturing" },
];

const companyLinks = [
  { label: "How It Works", href: "/how-it-works" },
  { label: "Pricing", href: "/pricing" },
  { label: "About Us", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#040810] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 pb-12 border-b border-white/5">
          <div className="lg:col-span-2 flex flex-col gap-4">
            <Link to="/">
              <span className="text-white font-extrabold text-lg tracking-tight">
                The Project<span className="text-electric-400"> Experts</span>
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              AI workforce automation for businesses that want results in days — not months. No IT project. No coding.
            </p>
            <div className="flex items-center gap-3 mt-2">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 text-slate-400 hover:text-electric-400 hover:bg-electric-500/10 transition-all duration-200 cursor-pointer"
                rel="nofollow"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 text-slate-400 hover:text-electric-400 hover:bg-electric-500/10 transition-all duration-200 cursor-pointer"
                rel="nofollow"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 text-slate-400 hover:text-electric-400 hover:bg-electric-500/10 transition-all duration-200 cursor-pointer"
                rel="nofollow"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">
              <a href="#products">Products</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {productLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    className="text-slate-400 text-sm hover:text-electric-400 transition-colors duration-200 cursor-pointer"
                    to={link.href}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">
              <a href="#solutions">Solutions</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {solutionLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    className="text-slate-400 text-sm hover:text-electric-400 transition-colors duration-200 cursor-pointer"
                    to={link.href}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">
              <a href="#company">Company</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {companyLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    className="text-slate-400 text-sm hover:text-electric-400 transition-colors duration-200 cursor-pointer"
                    to={link.href}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">© 2026 The Project Experts. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-slate-500 text-xs hover:text-slate-300 transition-colors cursor-pointer" rel="nofollow">Privacy Policy</a>
            <span className="text-slate-700">|</span>
            <a href="#" className="text-slate-500 text-xs hover:text-slate-300 transition-colors cursor-pointer" rel="nofollow">Terms of Service</a>
            <span className="text-slate-700">|</span>
            <a href="#" className="text-slate-500 text-xs hover:text-slate-300 transition-colors cursor-pointer" rel="nofollow">Cookie Settings</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
